import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
 
const Layout = ({children}) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
 
    return(
       <div className="min-h-screen bg-slate-50">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}  onCollapsedChange={setSidebarCollapsed} />
 
        <div className={`transition-all duration-300 ${sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'}`}> 
        <Header onMenuClick={() => setSidebarOpen(true)} />

        <main className="p-8">
            {children}
         
        </main>
      </div>
    </div>
 
  
    )
   
}
export default React.memo(Layout)